import { Id, Maybe } from '@vimeo/core/types/generic';
import { TeamUser } from '@vimeo/viewer';

import { updateTrackingConfig } from './utils';
import { useIsomorphicLayoutEffect } from '../../hooks/react/useIsomporphicLayoutEffect';
import {
  EComposerApplicationType,
  EComposerSessionType,
  TComposerSessionId,
} from '../../types/composer_session';
import { getLiveApplicationGlobals, updateDatadogGlobals } from '../../utils/tracking';

interface IUseGlobalDetailsSyncProps {
  sessionApplicationType?: Maybe<EComposerApplicationType>;
  sessionType?: Maybe<EComposerSessionType>;
  sessionId?: Maybe<TComposerSessionId>;
  userId?: Maybe<Id>;
  userLocale?: Maybe<string>;
  teamOwnerId?: Maybe<Id>;
  teamAccountType?: Maybe<string>;
  teamUser?: Maybe<TeamUser>;
}

/**
 * Hook to sync some app-level globals.
 * Updates live applications Big Picture tracking schemas and global Datadog fields.
 */
export function useApplicationTrackingDetailsSync({
  sessionApplicationType = null,
  sessionType = null,
  sessionId = null,
  userId = null,
  userLocale = null,
  teamOwnerId = null,
  teamAccountType = null,
  teamUser = null,
}: IUseGlobalDetailsSyncProps) {
  useIsomorphicLayoutEffect(() => {
    updateTrackingConfig({
      DETAILS: {
        SESSION_APPLICATION: sessionApplicationType,
        SESSION_TYPE: sessionType,
        SESSION_ID: sessionId,
        USER_ID: userId,
        USER_LOCALE: userLocale,
      },
      BIG_PICTURE_TEAM_CONTEXT_BASE: {
        teamOwnerId,
        teamAccountType,
        teamUser,
      },
    });

    updateDatadogGlobals(getLiveApplicationGlobals());
  }, [sessionApplicationType, sessionType, sessionId, userId, userLocale]);
}
